import React from 'react';
import './deposit.css';
import axios from 'axios';

export function Deposit() {

    const onDeposit = (e) => {
        e.preventDefault();
        const acId = e.target.acId.value;
        const amount = e.target.amount.value;
        console.log(`Id ${acId} Amount ${amount}`);

        axios('https://www.tigerbank.store/deposit', {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ acId, amount: parseFloat(amount.replace(/,/g, '')) }), // 수정된 부분
        })
        .then(json =>{
            console.log(json)
        })
        .catch(error=>{
            console.error('데이터 요청이 실패하였습니다.',error)
        })
    }

    return (
        <div className="depCont">
            <div className="p--section">
                <h1>현금입금</h1>
                <form onSubmit={onDeposit}>
                    <input type='number' placeholder='계좌 번호' name='acId'/>
                    <input type='number' placeholder='금액' name='amount'/>
                    <input type='submit' value='입금' />
                </form>
            </div>
        </div>
    );
}

export default Deposit;
